import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../../types/ApprovalOperation';
import { ApprovalOperationI18n } from '../i18n/ApprovalOperationI18n';
import { ApprovalTypes } from '../../types';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalModalFooter = ({
  approvalType,
  approvalOperation,
  disablePrimaryButton,
  onCancel,
  isLoading,
  showFeedbackSurvey,
  buttonUse
}) => {
  const triggerSurvey = () => {
    if (showFeedbackSurvey && approvalType !== ApprovalTypes.QUOTE && (approvalType === ApprovalTypes.DEAL || approvalOperation === ApprovalOperation.APPROVE || approvalOperation === ApprovalOperation.REQUEST)) {
      showFeedbackSurvey();
    }
  };
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(LoadingButton // Using loading button to prevent user clicking multiple times
    , {
      "data-test-id": `product-approvals-approval-submit-button-${approvalOperation}`,
      loading: isLoading,
      failed: true // failed is used to not show success icon on finish
      ,
      use: buttonUse || 'primary',
      type: "submit",
      disabled: disablePrimaryButton,
      onClick: triggerSurvey,
      children: /*#__PURE__*/_jsx(ApprovalOperationI18n, {
        approvalOperation: approvalOperation
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      onClick: onCancel,
      "data-test-id": "product-approvals-modal-cancel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.cancel"
      })
    })]
  });
};